<template>
  <div v-if="isPickSubjectActiveLocal">
    <div class="vx-row ml-1">
      <div class="vx-col">
        <vx-card card-background="transparent" class="remove-shadow card__no-padding" style="width: 277px">
          <vx-input-group>
            <vs-button
              :disabled="true"
              size="large"
              style="color:white;"
              class="button__fully-opaque button-text__left-align remove-shadow header_button-lookalike"
              type="filled"
              color="">
              You have selected:
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="ml-0">
      <div class="vx-row">
        <div class="vx-col w-full sm:w-full xs:w-full md:w-full lg:w-1/2">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="MessageCircleIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickLanguage">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedLanguage }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
        <div class="vx-col w-full sm:w-full xs:w-full md:w-full lg:w-1/2">
          <vx-card card-background="transparent" class="mb-4 glow-effect_dark card__no-padding">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_dark input-group_prepend-slot-bg">
                  <span><feather-icon class="pt-1" icon="BookmarkIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                size="large"
                class="w-full button-text__left-align glow-effect_primary__hover back-button"
                style="border-radius:0 7px 7px 0"
                type="filled"
                color="#262d4a"
                @click="backToPickGrade">
                <span id="backArrow"><feather-icon class="pt-1 back-icon__hover-only" icon="ArrowLeftIcon" svg-classes="stroke-current"></feather-icon></span>
                {{ selectedGrade.name }}
              </vs-button>
            </vx-input-group>
          </vx-card>
        </div>
      </div>
    </div>
    <div class="vx-row mt-3">
      <div class="vx-col">
        <vx-card card-background="transparent" class="remove-shadow card__no-padding" style="width: 277px">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text remove-shadow" style="background-color: transparent">
                <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button
              :disabled="true"
              size="large"
              class="button__fully-opaque button-text__left-align remove-shadow header_button-lookalike text__school-font-color"
              type="filled"
              color="">
              Select a Subject
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
    </div>
    <div class="ml-4">
      <div class="vx-row mr-0" v-for="(_subject, index) in subjects" :key="index">
        <vx-card class="mb-4 glow-effect_dark card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_dark grade-symbol input-group_prepend-slot-bg">
                <img height="25" :src="getIcon(_subject.id)" />
              </div>
            </template>

            <vs-button
              size="large"
              class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
              style="border-radius:0 7px 7px 0;"
              @click="selectSubject(_subject)">
              {{ _subject.name }}
            </vs-button>
          </vx-input-group>
        </vx-card>
      </div>
      <div class="vx-row">
        <div class="vx-col mx-auto">
          <p v-if="showComingSoon" style="color:white;font-weight:500;font-size:16px;padding-top:5px">There are currently no subjects for {{ selectedGrade.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import defaultIcon from '../../../../assets/subjecticons/default.svg'
import mathsIcon from '../../../../assets/subjecticons/maths.svg'
import mathsliteracyIcon from '../../../../assets/subjecticons/maths-literacy.svg'
import afrikaanshomeIcon from '../../../../assets/subjecticons/afrikaans-home.svg'
import afrikaansfirstIcon from '../../../../assets/subjecticons/afrikaans-first.svg'
import englishhomeIcon from '../../../../assets/subjecticons/english-home.svg'
import englishfirstIcon from '../../../../assets/subjecticons/english-first.svg'
import lifeskillsIcon from '../../../../assets/subjecticons/life-skills.svg'
import lifesciencesIcon from '../../../../assets/subjecticons/life-sciences.svg'
import socialscienceIcon from '../../../../assets/subjecticons/social-science.svg'
import lifeorientationIcon from '../../../../assets/subjecticons/life-orientation.svg'
import naturalscienceandtechnologyIcon from '../../../../assets/subjecticons/natural-science-and-technology.svg'
import geographyIcon from '../../../../assets/subjecticons/geography.svg'
import economicsIcon from '../../../../assets/subjecticons/economics.svg'
import accountingIcon from '../../../../assets/subjecticons/accounting.svg'
import tourismIcon from '../../../../assets/subjecticons/tourism.svg'
import naturalscienceIcon from '../../../../assets/subjecticons/natural-science.svg'
import historyIcon from '../../../../assets/subjecticons/history.svg'
import egdIcon from '../../../../assets/subjecticons/eng-graphics-and-design.svg'
import technologyIcon from '../../../../assets/subjecticons/technology.svg'
import computerapptechnologyIcon from '../../../../assets/subjecticons/computer-app-technology.svg'
import itIcon from '../../../../assets/subjecticons/it.svg'
import electricaltechnologyIcon from '../../../../assets/subjecticons/electrical-technology.svg'
import mechanicaltechnologyIcon from '../../../../assets/subjecticons/mechanical-technology.svg'
import civiltechnologyIcon from '../../../../assets/subjecticons/civil-technology.svg'
import businessstudiesIcon from '../../../../assets/subjecticons/business-studies.svg'
import consumerstudiesIcon from '../../../../assets/subjecticons/consumer-studies.svg'
import physicalscienceIcon from '../../../../assets/subjecticons/physical-science.svg'
import chessIcon from '../../../../assets/subjecticons/chess.svg'
import creativeartsIcon from '../../../../assets/subjecticons/creative-arts.svg'
export default {
  props: {
    isPickSubjectActive: {
      type: Boolean,
      required: true
    },
    selectedLanguage: {
      type: String,
      required: false
    },
    selectedGrade: {
      required: false
    },
    subjects: {
      required: false
    },
    showComingSoon: {
      required: false
    }
  },
  data() {
    return {
      math: [38,39,47,51,54,55,56,57,58,59,89,130,139,141,143,145,148,150,176,189,196,225,236,248,259,261,341,361,367,380,388,389,398,400,408,412,417],
      mathLit: [44,115,124,266,268,269,349,368,393],
      afrHuis: [40,41,60,61,62,63,165,201,202,204,250,252,258],
      afrEat: [46,64,78,80,91,200,206,211,213,238,239,240,676],
      engHome: [52,90,92,98,100,131,215,228,232,235,244,245,246],
      engFal: [53,81,82,83,132,163,192,193,195,241,242,243,332,343,370,390,399,518],
      lifeSkill: [45,49,79,88,103,104,109,110,197,198,334,409,410,414,421],
      lifeScience: [48,106,113,310,311,313,359,371,395],
      socScience: [71,72,116,117,118,119,126,184,186,187,205,207],
      lifeOrient: [84,85,86,154,155,157,249,251,253,255,256,257,527],
      natSciTech: [42,50,74,77,185,191],
      geography: [94,95,96,97,99,105,344,378,391],
      econManSci: [120,122,125,175,177,178],
      economics: [128,133,135,229,230,231,354,376,394],
      accounting: [136,138,146,210,212,216,345,373,392],
      tourism: [156,158,160,180,199,348,372,403,511,512,513],
      natScience: [111,112,114,181,182,183],
      history: [140,142,144,147,149,151,342,374,404,429],
      egd: [127,129,134,260,263,267],
      tech: [171,172,174,188,190,194],
      compAppTech: [137,152,161,214,220,223],
      it: [164,167,179,270,271,272],
      elecTech: [291,292,293],
      mechTech: [315,316,317],
      civilTech: [318,319,320],
      busStudy: [153,159,166,219,221,222,346,365,405,495,506,507],
      consStud: [168,170,173,233,234,237],
      physScience: [208,209,218,224,226,227,347,369,397],
      chess: [335,336,337,338],
      agriSci: [350,366,402],
      arts: [362],
      isixhosa: [333,352,387,401],
    };
  },
  computed: {
    isPickSubjectActiveLocal: {
      get() {
        return this.isPickSubjectActive;
      }
    }
  },
  methods: {
    selectSubject(subject) {
      var icon = this.getIcon(subject.id);
      this.$emit("subjectSelected", subject, icon);
    },
    getIcon(id) {
      var self = this;
              
      if (self.math.includes(id))
        return mathsIcon;
      else if (self.mathLit.includes(id))
        return mathsliteracyIcon;
      else if (self.afrHuis.includes(id))
        return afrikaanshomeIcon;
      else if (self.afrEat.includes(id))
        return afrikaansfirstIcon;
      else if (self.engHome.includes(id))
        return englishhomeIcon;
      else if (self.engFal.includes(id))
        return englishfirstIcon;
      else if (self.lifeSkill.includes(id))
        return lifeskillsIcon;
      else if (self.lifeScience.includes(id))
        return lifesciencesIcon;
      else if (self.socScience.includes(id))
        return socialscienceIcon;
      else if (self.lifeOrient.includes(id))
        return lifeorientationIcon;
      else if (self.natSciTech.includes(id))
        return naturalscienceandtechnologyIcon;
      else if (self.geography.includes(id))
        return geographyIcon;
      else if (self.economics.includes(id))
        return economicsIcon;
      else if (self.accounting.includes(id))
        return accountingIcon;
      else if (self.tourism.includes(id))
        return tourismIcon;
      else if (self.natScience.includes(id))
        return naturalscienceIcon;
      else if (self.history.includes(id))
        return historyIcon;
      else if (self.egd.includes(id))
        return egdIcon;
      else if (self.tech.includes(id))
        return technologyIcon;
      else if (self.compAppTech.includes(id))
        return computerapptechnologyIcon;
      else if (self.it.includes(id))
        return itIcon;
      else if (self.elecTech.includes(id))
        return electricaltechnologyIcon;
      else if (self.mechTech.includes(id))
        return mechanicaltechnologyIcon;
      else if (self.civilTech.includes(id))
        return civiltechnologyIcon;
      else if (self.busStudy.includes(id))
        return businessstudiesIcon;
      else if (self.consStud.includes(id))
        return consumerstudiesIcon;
      else if (self.physScience.includes(id))
        return physicalscienceIcon;
      else if (self.chess.includes(id))
        return chessIcon;
      else if (self.arts.includes(id))
        return creativeartsIcon;
      else
        return defaultIcon;
    },
    backToPickLanguage() {
      this.$emit("backToPickLanguage");
    },
    backToPickGrade() {
      this.$emit("backToPickGrade");
    }
  },
  mounted() {
    
  }
};
</script>